export const SEO_DATA = {
  '/': {
    title: 'Mzansi Save - Modern Digital Stokvels | Safe • Simple • Smart',
    description: 'Join the modern stokvel revolution. R100 joining fee, no group limits.',
    keywords: 'stokvels, digital stokvels, mzansi save, group savings, community savings, sharenet, blockchain transparency, south africa savings',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      "name": "Mzansi Save",
      "description": "Modern digital stokvel platform modernizing South Africa's traditional savings communities with bank-grade security and blockchain transparency",
      "url": "https://www.mzansisave.co.za",
      "logo": "https://www.mzansisave.co.za/logo.png",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "Office 301, Imperial Terraces, Tyger Waterfront, Carl Cronje Drive",
        "addressLocality": "Bellville",
        "addressRegion": "Western Cape",
        "postalCode": "7530",
        "addressCountry": "ZA"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+27217004800",
        "email": "info@mzansisave.co.za",
        "contactType": "customer service",
        "availableLanguage": ["en", "af", "zu", "xh"]
      },
      "founder": "Sharenet (Pty) Ltd",
      "foundingDate": "2024",
      "sameAs": [
        "https://www.linkedin.com/company/mzansi-save",
        "https://www.facebook.com/mzansisave"
      ]
    }
  },
  '/about-us': {
    title: 'About Mzansi Save - Modernizing South Africa\'s Stokvel Tradition',
    description: 'Learn how Mzansi Save modernizes stokvels , Sharenet oversight, and blockchain transparency. Serving 11+ million South Africans pooling R50+ billion annually.',
    keywords: 'about mzansi save, stokvel history, sharenet fsca, south africa stokvels, community savings history',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      "mainEntity": {
        "@type": "FinancialService",
        "name": "Mzansi Save",
        "description": "Modernizing South Africa's 11+ million stokvel members and R50+ billion annual savings with digital innovation"
      }
    }
  },
  '/contact-us': {
    title: 'Contact Mzansi Save - Bellville Office | Support & Enquiries',
    description: 'Contact Mzansi Save for stokvel enquiries, Graduate Agents programme, or partnership opportunities. Bellville office: 021 700 4800 | info@mzansisave.co.za',
    keywords: 'contact mzansi save, bellville office, stokvel support, graduate agents enquiries, partnership opportunities',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "ContactPage",
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "Mzansi Save",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office 301, Imperial Terraces, Tyger Waterfront, Carl Cronje Drive",
          "addressLocality": "Bellville",
          "addressRegion": "Western Cape",
          "addressCountry": "ZA"
        },
        "telephone": "+27217004800",
        "email": "info@mzansisave.co.za"
      }
    }
  },
  '/academy': {
    title: 'Mzansi Stokvel Academy - Free Financial Literacy & Stokvel Education',
    description: 'Master stokvel fundamentals and financial literacy with our free online academy. 10 modules covering budgeting, saving, stokvel management, and more. Self-paced learning with assessments.',
    keywords: 'stokvel academy, financial literacy education, free online learning, stokvel training, budgeting course, south africa financial education, community savings education',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "Course",
      "name": "Mzansi Stokvel Graduate Agent Academy",
      "provider": {
        "@type": "Organization",
        "name": "Mzansi Save"
      },
      "description": "Comprehensive online academy covering stokvel fundamentals, financial literacy, and community engagement skills",
      "educationalLevel": "Beginner to Intermediate",
      "learningResourceType": "Online Course",
      "teaches": [
        "Stokvel fundamentals and history",
        "Financial literacy and budgeting",
        "Saving and interest concepts",
        "Fraud prevention and scam identification",
        "Community engagement skills"
      ],
      "courseMode": "online",
      "isAccessibleForFree": true,
      "hasCourseInstance": {
        "@type": "CourseInstance",
        "courseMode": "online",
        "instructor": {
          "@type": "Organization",
          "name": "Mzansi Save Academy"
        }
      }
    }
  },
  '/graduate-agents': {
    title: 'Graduate Agents Programme - Youth Employment & Financial Literacy',
    description: '8-week programme for unemployed youth (18-35). Learn financial literacy, stokvel management, community outreach. R0 fees, stipend opportunities, certificate completion.',
    keywords: 'graduate agents programme, youth employment, financial literacy, stokvel training, unemployed youth, community outreach, south africa jobs',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "EducationalProgram",
      "name": "Graduate Agents Programme",
      "provider": {
        "@type": "Organization",
        "name": "Mzansi Save"
      },
      "description": "8-week blended learning programme training unemployed youth in financial literacy and community stokvel support",
      "educationalLevel": "Certificate",
      "timeToComplete": "P8W",
      "applicationDeadline": "2024-12-31"
    }
  },
  '/how-it-works': {
    title: 'How Digital Stokvels Work - Save Together, Grow Faster',
    description: 'Discover how modern stokvels work: create groups, automate contributions, transparent tracking, secure payouts. ',
    keywords: 'how stokvels work, digital stokvel process, automated contributions, transparent savings, group savings, stokvel management',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "HowTo",
      "name": "How to Use Digital Stokvels",
      "description": "Step-by-step guide to modern stokvel participation",
      "step": [
        {
          "@type": "HowToStep",
          "name": "Sign Up",
          "text": "Create your secure profile with SA mobile number and ID"
        },
        {
          "@type": "HowToStep",
          "name": "Join or Create Group",
          "text": "Create new stokvel or join existing group with customizable rules"
        },
        {
          "@type": "HowToStep",
          "name": "Start Saving",
          "text": "Make contributions via EFT or supported retailers with automatic tracking"
        }
      ]
    }
  },
  '/constitution': {
    title: 'Mzansi Save Stokvel Co Constitution (2025)',
    description: 'Read the binding governance charter for Mzansi Save Stokvel Co, outlining rules, compliance requirements, digital governance, and member obligations.',
    keywords: 'stokvel constitution, mzansi save constitution, stokvel rules, governance charter, compliance, south africa stokvel',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Mzansi Save Stokvel Co - Constitution (2025)",
      "description": "Binding governance charter with rules, compliance standards, and annexures for Mzansi Save Stokvel Co."
    }
  },
  '/termsofuse': {
    title: 'Mzansi Stokvel Co Terms of Use',
    description: 'Read the Terms of Use governing access to the Mzansi Stokvel Co Platform, including member obligations, compliance, and platform rules.',
    keywords: 'terms of use, mzansi stokvel co terms, platform rules, user obligations, compliance, stokvel platform terms',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Mzansi Stokvel Co Terms of Use",
      "description": "Terms of Use governing access to and use of the Mzansi Stokvel Co Platform."
    }
  },
  '/privacy': {
    title: 'Mzansi Stokvel Co Privacy & Cookie Policy',
    description: 'Learn how Mzansi Stokvel Co collects, uses, shares, and protects personal information in line with POPIA and applicable law.',
    keywords: 'privacy policy, cookie policy, POPIA, data protection, mzansi stokvel co privacy',
    structuredData: {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Mzansi Stokvel Co Privacy & Cookie Policy",
      "description": "Privacy and cookie policy outlining data handling, security, and user rights under POPIA."
    }
  },

};

export const getSEOData = (pathname) => {
  return SEO_DATA[pathname] || {
    title: 'Mzansi Save - Modern Digital Stokvels',
    description: 'Transform your community savings with Mzansi Save digital stokvels. Bank-grade security, blockchain transparency, automated contributions.',
    keywords: 'Mzansi Save, digital stokvels, community savings, group savings, south africa'
  };
};
